import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useOperatoreContext } from "@/lib/operatoreContext";
import { cn } from "@/lib/utils";

export function CreateMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { registroId } = useOperatoreContext();

  const go = (path: string) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div className="relative px-3 pb-2">
      <Button
        className="w-full justify-between"
        size="sm"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="flex items-center gap-2">
          <Plus className="h-4 w-4" /> Crea
        </span>
        <ChevronDown className={cn("h-4 w-4 transition", open && "rotate-180")} />
      </Button>
      {open && (
        <div className="absolute left-3 right-3 top-full z-50 mt-1 rounded-md border bg-popover p-1 shadow-md">
          <button
            type="button"
            className="w-full rounded px-3 py-2 text-left text-sm hover:bg-accent"
            onClick={() => go(registroId ? `/registri?registro=${encodeURIComponent(registroId)}&nuovo=1` : "/registri")}
          >
            Movimento carico/scarico
          </button>
          <button
            type="button"
            className="w-full rounded px-3 py-2 text-left text-sm hover:bg-accent"
            onClick={() => go("/formulari?nuovo=1")}
          >
            Formulario digitale
          </button>
          <button
            type="button"
            className="w-full rounded px-3 py-2 text-left text-sm hover:bg-accent"
            onClick={() => go("/vidimazione")}
          >
            Formulario cartaceo
          </button>
        </div>
      )}
    </div>
  );
}
